<template>
  <div class="fzmOrderForEventWrapper">
    
    <div class="orderForEventInner">
        <div class="container">
            <b-row>
                <b-col cols="12" lg="5">
                    <h1>Have a large event soon? <span class="fzmBreakLine"></span> Let us help you out.</h1>
                    <p>Lorem ipsum consectetur adipiscing elit sed do eiusmod. Minimum order of {{eventminorder}} dozen.</p>
                </b-col>
            </b-row>

            <div class="orderOption">
                <div class="orderOptionItem">
                    <b-dropdown>
                        <template #button-content>
                            {{orderboxes.length}} Dozen <b-icon icon="chevron-down"></b-icon>
                        </template>

                        <template v-for="box in ordereventboxtypes">
                            <b-dropdown-item-btn @click="selectdozen(box)" :key="box.id">{{box.box_name}}</b-dropdown-item-btn>
                        </template>
                    </b-dropdown>
                </div>

                <div class="orderOptionItem">

                    <b-form-checkbox
                        v-model="isassorted"
                        @change="markallassorted"
                        :value="true"
                        :unchecked-value="false"
                        >
                        Mark all as assorted
                    </b-form-checkbox>
                   
                </div>
            </div>

            <div class="orderFlavorSelections">

                <b-row>
                    <template v-for="(box, index) in orderboxes" >
                        <b-col
                            :key="index"
                            cols="6"
                            md="3"
                            lg="2">
                                <b-dropdown 
                                    @shown="showdpitems = index"
                                    :class="[{'noselection' : !box.box_name}]">
                                    <template #button-content>
                                        <span class="selectedflavor">
                                            {{box.box_name ? box.id == assortedbox.id ? assortedbox.box_name : getboxflavor(box) : 'Select' }} 
                                        </span>
                                        
                                        <template v-if="box.flavors.length == 0">
                                            <span class="dpcaret"><b-icon icon="chevron-down"></b-icon></span>
                                        </template>
                                    </template>

                                    <b-dropdown-item-btn @click="selectboxflavor(index, 'assorted')">Assorted</b-dropdown-item-btn>

                                    <template v-if="showdpitems == index">
                                        <template v-for="(flavor, flavorindex) in flavors">
                                            <b-dropdown-item-btn 
                                                @click="selectboxflavor(index, flavor.id)"
                                                :key="'flavor'+flavorindex">{{flavor.name}}</b-dropdown-item-btn>
                                        </template>
                                    </template>
                                    
                                </b-dropdown>
                        </b-col>
                    </template>

                    
                </b-row>
                
            </div>

            <b-row>
                <b-col cols="12">
                         <button 
                            :disabled="!orderboxescomplete"
                            @click.prevent="$router.push({name : 'checkout'})"
                            class="btn btn-primary checkoutBtn">
                            Checkout
                        </button>
                    </b-col>
            </b-row>
        </div>
    </div>
</div>
</template>

<script>
//  components

// mixins
import {ordermixins} from '@/mixins/ordermixins'

export default {
    mixins : [ordermixins],
    data() {
        return {
            ordereventboxtypes: [],
            isassorted        : false,
            showdpitems       : 0
        }
    },
    computed : {
        /**
         * Event minumun order
         */
        eventminorder() {
            const minsettings = this.settings.find(sett => sett.settings_field.match(/(event_minimum)/g))
            return minsettings ? minsettings.settings_value : 0;
        },
        /**
         * Previous page
         */
        routefrom(){
            return this.$store.state.routefrom
        },
        /**
         * Selected dozen
         */
        selecteddozen() {
            const count = this.orderboxes.length;
            const boxtype = this.ordertypes.find(type => type.box_name.toLowerCase().indexOf(`${count}`) && type.box_type == 'event');

            return boxtype ? boxtype : null
        }
    },
    methods : {
        /**
         * Get number boxes options
         */
        getdozenoptions() {
            const options = this.ordertypes
                .filter(bx => bx.box_type == 'event' || bx.box_type == 'all' );
                

            this.ordereventboxtypes = options;
            
        },
        /**
         * Set all boxes flavors to assorted
         */
        markallassorted(state) {
            if(state) {
                const orderboxes = this.orderboxes.map(box => {
                    box.id       = this.assortedbox.id;
                    box.box_name = this.assortedbox.box_name;
                    box.flavors  = this.flavors.map(f => f.id);
                    return box;
                });

                this.orderboxes = orderboxes;

            }
        },
        /**
         * Get box flavor
         * this will be for 1 flavor selection only
         * @param {Object} box 
         * @return {String} flavor
         */
        getboxflavor(box) {
            const [flavor] = box.flavors;
            const foundflavor = this.flavors.find(f => f.id == flavor);

            return foundflavor ? foundflavor.name : '';
        },
        /**
         * Reset boxes to default value 
         * each boxes will have unique boxid to prevent 
         * min boxes will be 50
         * 
         * reset cardconnect object
         */
        defaultboxes() {
            // check order type subscription or event
            this.$store.commit('updateordertype', false);
            const [firstboxnumberoption] = this.ordereventboxtypes;

             if(this.routefrom.name != 'checkout' && firstboxnumberoption) { 
                 const resetboxes = Array.from({length : firstboxnumberoption.limit_flavors}, () => (this.newboxproperty()));
                 this.orderboxes = resetboxes.map(box => {
                    box.price = this.selecteddozen ? parseFloat(this.selecteddozen.box_price) : 0;
                    return box;
                });
             }

            this.$store.commit('updatecarddetails', null);
        },
        /**
         * Set number of boxes user going to order
         * @param {Object} type
         */
        selectdozen(type) {
            /**
             * Generate boxes 
             * and resets
             */
            this.isassorted = false;
            this.orderboxes = [];

            do {
                const chunking        = type.limit_flavors > 4 &&  type.limit_flavors % 4 === 0 ?  4 : 1;
                let   boxes           = this.generateboxarray(chunking);
                      this.orderboxes = [...this.orderboxes, ...boxes]
            } while (this.orderboxes.length < type.limit_flavors);


            /**
             * Get box price
             * (disabled because price are now in settings)
             */
            // this.orderboxes      = boxes.map(box => {
            //     box.price = this.selecteddozen ? parseFloat(this.selecteddozen.box_price) : 0;
            //     return box;
            // });
        },
        /**
         * Generate array by chunk
         * array will be added by 5
         * @param {Number} number number of boxes that will generate
         */
        generateboxarray(number) {
            /**
             * Check if 
             */

           return Array.from({length : number}, () => (this.newboxproperty(false, 'event')));
        },
        /**
         * Assign box with flavor
         */
        selectboxflavor(index, flavor) {
            let box = this.orderboxes[index];


          

            if(flavor == 'assorted') {
                box.id       = this.assortedbox.id;
                box.box_name = this.assortedbox.box_name;
                box.flavors  = this.flavors.map(f => f.id);
            } else {

                  /**
                 * If assorted fill the box of 1 of each flavor
                 * get 1 flavor type data
                 */
                const oneflavor = this.ordertypes.find(type => type.box_name.toLowerCase().indexOf('1 flavor') >= 0);
                console.log(oneflavor, 'flavor selected', flavor);
                
                /**
                 * Fill the box with flavor selected
                 */
                
                box.id     = oneflavor.id;
                box.box_name = oneflavor.box_name;
                box.flavors  = new Array(12).fill(flavor);

                /**
                 * Check if mark all as assorted is checked 
                 * and if one of the box change flavor
                 * unchecked the mark all as assorted 
                 */

                if(this.isassorted) {
                    this.isassorted = false;
                }
            }

        }
    },
    /**
     * Run function before component render
     */
    async beforeMount() {
        // Boxes type
        await this.$store.dispatch('getboxtypes');
        this.$store.dispatch('getflavors');
        //Reset orderbox every time user visit this page
        await this.getdozenoptions();
        this.defaultboxes();
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';
@import '@/scss/global/_mixins.scss';

.fzmOrderForEventWrapper {
    .orderForEventInner {
        @include screen-up(lg) {
            padding-top : 30px;
        }

        .orderOption {
            @include screen-up(lg) {
                padding-top : 30px;
            }
        }

        .checkoutBtn {
            height       : 40px;
            margin-bottom: 30px;
            margin-top   : auto;
            margin-bottom: auto;

            @include screen-up(lg) {
                display: block;
                width  : 100%;
            }
        }
    }

    .orderOption {
        .dropdown {
            .dropdown-toggle {
                border-radius: 30px;
                padding-left : 30px;
                padding-right: 15px;
                color        : $black;
                font-weight  : 500;

                svg {
                    margin-left: 10px;
                    font-size  : 12px;
                    position   : relative;
                    top        : -2px;
                }

                &::after {
                    display: none;
                }
            }
        }
    }

    .orderFlavorSelections {
        .dropdown {
            display: block;

            .dropdown-toggle {
                font-weight: 700;
                white-space: pre-wrap;
                text-align : left;
                font-size  : 10px;
                height     : auto;
                flex : 1;

                .selectedflavor {
                    word-break: normal;
                    font-size : 10px;
                    flex      : 1;
                    hyphens   : auto;

                }

                .dpcaret {
                    position: relative;
                    top     : 2px;
                }
            }

            .dropdown-menu {
                max-height: 300px;
            }

            &.noselection {
                color : $disabled-color;

                .dropdown-toggle {
                    &::before {
                        background-color: $disabled-color;
                    }
                }
            }

            .dpcaret {
                margin-left : 10px;
                margin-right: 10px;
                color       : $disabled-color;
                font-size   : 10px;
                position    : relative;
                top         : -2px;
            }
        }   
    }
}
</style>